module.exports = __webpack_public_path__ + "img/interagent.a46c51a3.png";